.FloatingMenuItem {
  border-radius: var(--mantine-radius-default);
  padding: var(--mantine-spacing-2xs);
  font-size: var(--mantine-font-size-sm);
  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-gray-4));

  &[data-hovered] {
    background-color: light-dark(
      var(--mantine-color-gray-0),
      var(--mantine-color-gray-9)
    );
  }
}
